import React, { useState, useContext } from 'react';
import {
  Row,
  Col,
  Modal,
  Form,
  Alert,
  Button
} from 'react-bootstrap';
import {Uploader} from '../../components';
import _ from 'lodash';
import Utils from '../../Utils';
import UserContext from './../../contexts/UserContext';
import MessageModal from '../../components/MessageModal';

const AskTitle = (props) => {
  //let userData = Utils.getUserData();
  console.log(props);
  const [folderName, setfolderName] = useState(_.get(props, `data.fname`, ''));
  const logosize_in_mb =  _.get(process.env,'REACT_APP_MAX_LOGO_SIZE',1);
  const {getPkgSize, getAvailableSize} = useContext(UserContext);
  const [sprops,setSprops] = useState(_.get(props,'data.sprops', {title: '',photo:'',pass_score: ''}));
  const [errMsg,setErrMsg] = useState('');
  const [message, setMessage] = useState(false);

  const [mode,setMode] = useState(_.get(props,'mode',3));

  const onUploadPhoto = (attr,status) => {    
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${logosize_in_mb} MB. Try again with an acceptable sized file.`);
    }else{
      setErrMsg('');
      if(typeof attr === 'string') setSprops({...sprops, photo : attr});
    } 
  }

  const removeImageHandler = () => {
    if(window.confirm("Are you sure you want to remove the logo?")){
      setSprops({...sprops, photo:''});
    }
  }


  const submitTitleForm = (frm,lib = 0, blank = 0) => {
    
    if(frm.title.value===""){
      setMessage(['error', ['Please enter your brand name.']]);
      frm.title.focus();
    }else if(_.get(props,'countable',false) && (parseFloat(frm.pass_score.value) < 0 || parseFloat(frm.pass_score.value) >100)){
      setMessage(['error', ["Please enter a value from 0 to 100 as a pass score value for this SVASU."]]);
      frm.pass_score.focus();
    }else{
      let objVal = {...sprops,title:frm.title.value, pass_score: 0, chooseLibrary: lib, blankCourse: blank};
      if(props.countable){
        objVal['pass_score']= frm.pass_score.value;
      }
      props.onSuccess(objVal);
    }
  }


  const onSpropsSubmit = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    submitTitleForm(frm);
  }

  const initLibrary = (e) => {
    const btn = e.currentTarget;
    submitTitleForm(btn.form,1);
  }

  const initBlankCourse = (e) => {
    const btn = e.currentTarget;
    submitTitleForm(btn.form, 'no', 1);
  }

  const modalBody = () => {
    return (<><Row>
      <Col className="col-4">Your Brand Name</Col>
      <Col><Form.Control type="text" className="mb-3" name="title" defaultValue={sprops.title} placeholder="* Enter your brand name" /></Col>
    </Row>
    {_.get(props,'countable',false) && <Row>
      <Col className="col-4"><Form.Label>Set the Pass Percentage</Form.Label></Col>
      <Col><Form.Control type="text" className="mb-3" name="pass_score" defaultValue={_.get(sprops,'pass_score',100)} placeholder="* Score percentage" /></Col>
    </Row>}
    
    <Row>
      <Col className="col-4">Your Brand Logo</Col>
      <Col className="smimg"><img src={`${process.env.PUBLIC_URL}/images/Image-Icon.png`} alt="LOGO" /></Col>
    </Row>

    { sprops.photo === '' && <Row className="mt-3">
      <Col title="Select Logo Image"  className="text-left" style={{minHeight: '200px', maxHeight: '300px'}}>
        <Uploader 
        instructions={`Click the icon or drag and drop the file to upload your logo. The maximum file size allowed is ${logosize_in_mb} MB. Supported file formats are .jpg and .png only.`}
        accept="image/*" 
        maxSizeBytes={logosize_in_mb*1024*1024} 
        uploadUrl={Utils.apiUrl('saveupload')} 
        onUpload={onUploadPhoto} />
      </Col>    
    </Row> }
    {sprops.photo && <Row className="mt-3">
      <Col className="text-center" style={{minHeight:'200px', maxHeight:'auto'}}>
      <div className="logoContainer mb-3">
        <img  src={Utils.apiUrl(`image?f=${sprops.photo}&altd=${folderName}`)} alt="logo" className="scormLogo"/>
        <img src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} className="text-right scormRemove" onClick={removeImageHandler} alt="Remove" />
      </div>                                    
    </Col>
    </Row>} 
    {console.log((sprops.photo), "sprops")}
    {errMsg !== '' && <>
    <Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" />  {errMsg} </Alert>
    </>}</>)
  };


  return <Modal
      show={true}
      onHide={props.onHide}
      backdrop="static"
      keyboard={false}
      size={mode===3 ? (props.countable || props.edit) ?'md' : 'xl' : 'md'}
    >
      <Modal.Header closeButton className="setPropPopHeader">
        <Modal.Title>Set Properties for SVASU  {props.countable ? 'Quiz' : 'Course'}</Modal.Title>
        </Modal.Header>
      <Form onSubmit={onSpropsSubmit}  className="setPropPopForm">
        <Modal.Body>
          {mode!==3 && modalBody()}
          {mode===3 && <Row>
            <Col lg={(props.countable || props.edit) ? 12 : 6}>
              {(!props.countable  && !props.edit) && <h4 className="text-center">Step 1</h4>}
              {modalBody()}
            </Col>
            {(!props.countable && !props.edit) && <Col lg={6}>
              <h4 className="text-center">Step 2</h4>
              <Row>
                <Col className="text-center">
                  <Button type="button" onClick={initBlankCourse} className="active px-5 py-2">Create Blank Course</Button>
                </Col>
              </Row>
              <Row className="m-3 mt-4 mb-2">
                <Col lg={5}><hr /></Col>
                <Col lg={2} className="text-center">OR</Col>
                <Col lg={5}><hr /></Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button type="submit" className="active px-5 py-2">Create Using Our Existing Templates</Button>
                </Col>
              </Row>
              <Row className="m-3 mt-4 mb-2">
                <Col lg={5}><hr /></Col>
                <Col lg={2} className="text-center">OR</Col>
                <Col lg={5}><hr /></Col>
              </Row>
              <Row>  
                <Col className="text-center">
                  <Button type="button" onClick={initLibrary} className="active px-5 py-2">Explore Our Free, Comprehensive Course Library</Button>
                </Col>
              </Row>
            </Col>}
          </Row>}
        </Modal.Body>
        {(mode!==3 || props.countable || props.edit) && <Modal.Footer>          
          <Button type="submit" className="active px-5 py-2 float-right">Continue</Button>
        </Modal.Footer>}
      </Form>
      {message && <MessageModal type={message[0]} message={message[1]} onHide={setMessage} />}
    </Modal>
}

export default AskTitle;